// extracted by mini-css-extract-plugin
export default {"container":"TournamentCreator_container__a3w1T","title":"TournamentCreator_title__mz1QC"};